import { appInsights } from "./appInsights";
import { completeLoginTiming } from "./loginTiming";
import { APP_KPI_NAME } from "./utils";

export function trackScreenLoad(module: string, screen: string, startedAt: number) {
  const durationMs = performance.now() - startedAt;

  appInsights.trackMetric({
    name: APP_KPI_NAME.PCS_INITIAL_SCREEN_LOAD,
    average: durationMs,
    sampleCount: 1,
    properties: {
      module,
      screen,
    } as never,
  });

  appInsights.trackEvent({
    name: `${APP_KPI_NAME.PCS_INITIAL_SCREEN_LOAD}_completed`,
    properties: {
      module,
      screen,
      durationMs,
    },
  });

  completeLoginTiming({
    completedModule: module,
    completedScreen: screen,
  });
}
